"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MusicDetailsView = void 0;
const ITabNavigator_1 = require("../core/render/ITabNavigator");
const View_1 = require("../core/render/View");
const viewModelCollection_1 = require("../viewModelCollection");
class MusicDetailsView extends View_1.View {
    constructor(songId, viewNavigator) {
        super();
        this.viewNavigator = viewNavigator;
        this.IMAGE_SIZE = 550;
        this.dataContext = viewModelCollection_1.getMusicDetailsViewModel();
        this.renderBody = document.createElement("main");
        this.renderBody.classList.add("main-musicDetails");
        this.tabNavigator = new ITabNavigator_1.TabNavigator();
        this.dataContext.setSongId(songId).then(() => {
            this.dataContext.title = this.dataContext.songName;
            this.forceTitleUpdate();
            this.displayBanner(this.renderBody);
            let bodyDiv = document.createElement("div");
            bodyDiv.id = "musicDetailsBody";
            this.renderBody.appendChild(bodyDiv);
            this.dataContext.songEdited = () => {
                alert("Song Updated");
            };
            this.dataContext.refreshSong = () => {
                this.refresh();
            };
            this.displayPluginTabAMenu(bodyDiv);
        });
    }
    moveHome() {
        this.viewNavigator.navigate("Home", null);
    }
    refresh() {
        this.viewNavigator.navigate("MusicDetails", { songId: this.dataContext.songId });
    }
    displayBanner(html) {
        let bannerDiv = document.createElement("div");
        bannerDiv.classList.add("music-banner");
        let bannerImageDiv = document.createElement("div");
        bannerImageDiv.classList.add("music-banner-image-div");
        bannerDiv.appendChild(bannerImageDiv);
        let image = document.createElement("img");
        window.onresize = () => this.resizeImageDiv(bannerImageDiv, image.height);
        image.onload = () => this.resizeImageDiv(bannerImageDiv, image.height);
        image.classList.add("banner-image");
        image.src = this.dataContext.songBannerImageUrl;
        bannerImageDiv.appendChild(image);
        html.appendChild(bannerDiv);
        this.displayBannerControls(bannerDiv);
    }
    resizeImageDiv(bannerImageDiv, height) {
        bannerImageDiv.setAttribute("style", `height: ${(height <= this.IMAGE_SIZE) ? height : this.IMAGE_SIZE}px`);
        let navigationBar = document.querySelector("nav");
        let main = document.querySelector(".main-musicDetails");
        main.setAttribute("style", `margin-top: ${navigationBar.clientHeight}px`);
    }
    displayBannerControls(bannerDiv) {
        let bannerControl = document.createElement("div");
        bannerControl.classList.add("banner-controls");
        let heading = document.createElement("h1");
        heading.textContent = this.dataContext.songName;
        bannerControl.appendChild(heading);
        let bannerControlList = document.createElement("div");
        bannerControlList.classList.add("banner-controls-list");
        bannerControl.appendChild(bannerControlList);
        if (!this.dataContext.noAudioPresent) {
            let playLink = document.createElement("a");
            playLink.textContent = "Switch Audio";
            playLink.addEventListener("click", () => {
                this.dataContext.switchSong();
            });
            bannerControlList.appendChild(playLink);
        }
        let deleteLink = document.createElement("a");
        deleteLink.textContent = "Delete Song";
        deleteLink.addEventListener("click", () => {
            if (confirm("Are you sure you want to delete this song?")) {
                this.dataContext.deleteSong().then(() => this.moveHome());
            }
        });
        bannerControlList.appendChild(deleteLink);
        let exportLink = document.createElement("a");
        exportLink.textContent = "Export To JSON";
        exportLink.addEventListener("click", () => {
            this.dataContext.getSongJson().then(json => {
                let file = new Blob([json], { type: "text/plain" });
                let fileDownloader = document.createElement("a");
                fileDownloader.href = URL.createObjectURL(file);
                fileDownloader.download = "exportSong.json";
                fileDownloader.click();
            });
        });
        bannerControlList.appendChild(exportLink);
        bannerDiv.appendChild(bannerControl);
    }
    addMainTab(html, menuDiv) {
        return __awaiter(this, void 0, void 0, function* () {
            let homePanel = this.tabNavigator.addTabMenuItem(this.dataContext.homePanel.panelName, this.dataContext.homePanel.panelId, true, this.dataContext.homePanel);
            yield this.dataContext.homePanel.renderContent(homePanel, null);
        });
    }
    addSongPropertiesTab() {
        return __awaiter(this, void 0, void 0, function* () {
            let propertiesPanel = this.tabNavigator.addTabMenuItem(this.dataContext.songPropertiesPanel.panelName, this.dataContext.songPropertiesPanel.panelId, false, this.dataContext.songPropertiesPanel);
            yield this.dataContext.songPropertiesPanel.renderContent(propertiesPanel, null);
        });
    }
    loadPluginPanels() {
        return __awaiter(this, void 0, void 0, function* () {
            for (let panel of this.dataContext.loadedPluginPanels) {
                let panelWidget = this.tabNavigator.addTabMenuItem(panel.panelName, panel.panelId, false, panel);
                yield panel.renderContent(panelWidget, this.dataContext.getSongMetadataForPlugin(panel.basePlugin.pluginName));
            }
        });
    }
    displayPluginTabAMenu(html) {
        let menuDiv = document.createElement("div");
        html.appendChild(menuDiv);
        menuDiv.classList.add("tab");
        this.tabNavigator.parentContainer = html;
        this.tabNavigator.menuDiv = menuDiv;
        this.addMainTab(html, menuDiv).then(() => {
            this.addSongPropertiesTab().then(() => {
                this.loadPluginPanels();
            });
        });
    }
    shouldRender() {
        return true;
    }
}
exports.MusicDetailsView = MusicDetailsView;
//# sourceMappingURL=MusicDetailsView.js.map